<template>
  <div>
    <audio ref="player"></audio>
    <div
      class="wrappper-player"
      :style="activeIndex % 5 == 0 ? {} : { height: '48px' }"
    >
      <div
        class="bg-player"
        :class="activeIndex % 5 == 0 ? 'mainBar-player' : 'top-player'"
      ></div>
      <div
        class="control"
        :class="activeIndex % 5 == 0 ? 'mainBar-control ' : 'bar-control'"
      >
        <button @click="handleChangeRadio(-1)" class="prev">
          <i class="fas fa-step-backward"></i>
        </button>
        <button class="play" @click="toggleStatus">
          <i
            class="fas"
            :class="{
              'fa-play': isPlaying,
              'fa-pause': !isPlaying
            }"
          >
          </i>
        </button>
        <button @click="handleChangeRadio(1)" class="next">
          <i class="fas fa-step-forward"></i>
        </button>
      </div>
      <div class="voulme">
        <button @click="volumeNo" class="dinamic">
          <i ref="volumeIcon" class="fas fa-volume"></i>
        </button>
        <div class="slide-voulme">
          <input
            v-model="rangeValue"
            class="slide"
            :style="{
              background: `linear-gradient(to right, #ffffff 0% , #ffffff ${
                rangeValue == null ? 50 : rangeValue * 100
              }%  , #595959 0%, #595959 100%)`
            }"
            type="range"
            min="0"
            max="1"
            step="0.05"
          />
        </div>
      </div>
      <div class="radio-descr">
        <div class="img" :class="activeIndex % 5 == 0 ? 'main-img' : 'bar-img'">
          <img :src="radioInfo?.img" />
        </div>
        <div
          class="title limited-text"
          :class="activeIndex % 5 == 0 ? 'main-title' : 'bar-title'"
        >
          <span v-if="radioInfo?.data?.title">
            {{ radioInfo?.data?.title }}</span
          >
          <span v-else> {{ radioInfo?.name }}</span>
        </div>
      </div>
      <svg
        width="0"
        height="0"
        viewBox="0 0 115 115"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <clipPath id="round-player-btn" clipPathUnits="objectBoundingBox">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.336,0.5
        C0.336,0.757,0.303,0.966,0.262,0.966 C0.221,0.966,0.188,0.757,0.188,0.5
        C0.188,0.243,0.221,0.034,0.262,0.034 C0.303,0.034,0.336,0.243,0.336,0.5
        M0.193,1 H0 V0.115 C0,0.051,0.008,0,0.018,0 H0.193
        C0.171,0.121,0.157,0.3,0.157,0.5 C0.157,0.7,0.171,0.879,0.193,1
        M0.367,0.5 C0.367,0.7,0.353,0.879,0.33,1 H1 V0.115
        C1,0.051,0.992,0,0.982,0 H0.33 C0.353,0.121,0.367,0.3,0.367,0.5"
          />
        </clipPath>
        <clipPath id="player-btn" clipPathUnits="objectBoundingBox">
          <path
            d="M0.249,1 H0.339 C0.36,0.885,0.373,0.694,0.373,0.477 C0.373,0.287,0.363,0.117,0.346,0 H0.242 C0.225,0.117,0.215,0.287,0.215,0.477 C0.215,0.694,0.228,0.885,0.249,1 M0.202,1 C0.189,0.852,0.181,0.672,0.181,0.477 C0.181,0.302,0.187,0.139,0.198,0 H0.013 C0.006,0,0,0.047,0,0.104 V0.896 C0,0.953,0.006,1,0.013,1 H0.202 M0.39,0 C0.401,0.139,0.407,0.302,0.407,0.477 C0.407,0.672,0.399,0.852,0.386,1 H0.987 C0.994,1,1,0.953,1,0.896 V0.104 C1,0.047,0.994,0,0.987,0 H0.39"
          />
        </clipPath>
      </svg>
    </div>
    <div class="mobile-plyer">
      <div class="mobile-bg"></div>
      <div class="control-mobile">
        <button @click="handleChangeRadio(-1)" class="prev">
          <i class="fas fa-step-backward"></i>
        </button>
        <button class="play" @click="toggleStatus">
          <i
            class="fas"
            :class="{
              'fa-play': isPlaying,
              'fa-pause': !isPlaying
            }"
          >
          </i>
        </button>
        <button @click="handleChangeRadio(1)" class="next">
          <i class="fas fa-step-forward"></i>
        </button>
      </div>
      <div class="info-mobile">
        <div class="radio-name">
          <span> {{ radioInfo?.name }}</span>
        </div>
        <div class="radio-music">
          <span class="limited-text" style="--snup: 1">
            {{ radioInfo?.data?.title }}</span
          >
        </div>
      </div>
      <svg
        width="435"
        height="60"
        viewBox="0 0 435 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <clipPath id="player-bg-mobile" clipPathUnits="objectBoundingBox">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.375,0.5 C0.375,0.776,0.344,1,0.306,1 C0.268,1,0.237,0.776,0.237,0.5 C0.237,0.224,0.268,0,0.306,0 C0.344,0,0.375,0.224,0.375,0.5 M0.363,0 C0.383,0.119,0.395,0.299,0.395,0.5 C0.395,0.701,0.383,0.881,0.363,1 H1 V0 H0.363 M0.248,1 C0.229,0.881,0.216,0.701,0.216,0.5 C0.216,0.299,0.229,0.119,0.248,0 H0 V1 H0.248"
            fill="#D1D1D1"
          />
        </clipPath>
      </svg>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref, watch } from "vue";
import { useFormatter } from "@/utils/formatter";
import Hls from "hls.js";
import europa from "@/assets/lifestyle-page/radio/EuropaPlus.png";
import nrj from "@/assets/lifestyle-page/radio/Nrg.png";
import maxima from "@/assets/lifestyle-page/radio/Maxima.jpg";
import life from "@/assets/lifestyle-page/radio/LifeFM.png";
import zaycev from "@/assets/lifestyle-page/radio/zaycev.png";

export default {
  props: {
    activeIndex: {
      type: Number,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: false
    }
  },
  setup() {
    const player = ref(null);
    const isPlaying = ref(false);
    const volumeIcon = ref(null);
    const rangeValue = ref(null);
    const { moveArrayItemToNewIndex } = useFormatter();

    const toggleStatus = () => {
      if (player.value.paused) {
        player.value.play();
      } else {
        player.value.pause();
      }
      checkPlayer();
    };

    const checkPlayer = () => (isPlaying.value = player.value.paused);

    const volumeChange = () => {
      player.value.volume = rangeValue.value;
      if (rangeValue.value == null) {
        player.value.volume = 0.9;
      }
      if (rangeValue.value > 0.75) {
        volumeIcon.value.classList = "fas fa-volume-up";
      } else if (rangeValue.value < 0.75 && rangeValue.value > 0.5) {
        volumeIcon.value.classList = "fas fa-volume";
      } else if (rangeValue.value < 0.5 && rangeValue.value != 0) {
        volumeIcon.value.classList = "fas fa-volume-down";
      } else if (rangeValue.value == 0) {
        volumeIcon.value.classList = "fas fa-volume-mute";
      }
    };
    const volumeNo = () => {
      if (rangeValue.value == 0) {
        rangeValue.value = 0.5;
        player.value.volume = 0.5;
        volumeIcon.value.classList = "fas fa-volume-down";
      } else {
        rangeValue.value = 0;
        player.value.volume = 0;
        volumeIcon.value.classList = "fas fa-volume-mute";
      }
    };

    const radioInfo = reactive({});

    const listRadio = ref([
      {
        play: "https://hls-02-europaplus.emgsound.ru/11/128/playlist.m3u8",
        name: "Europa Plus",
        data: "https://scraper2.onlineradiobox.com/ru.europaplus.ru",
        img: europa
      },
      {
        play: "https://pub0302.101.ru:8443/stream/air/aac/64/99",
        name: "NRJ",
        data: "https://scraper2.onlineradiobox.com/ru.energyfm",
        img: nrj
      },
      {
        play: "http://80.80.222.26:8000/maximafm.ogg",
        name: "Maxima",
        data: "https://scraper2.onlineradiobox.com/uz.maxima1054",
        img: maxima
      },
      {
        play: "http://lifefm.uz:8000/radio-64.aac",
        name: "LifeFM",
        data: "https://scraper2.onlineradiobox.com/uz.life",
        img: life
      },
      {
        play: "https://zaycevfm.cdnvideo.ru/ZaycevFM_pop_256.mp3",
        name: "Зайцев FM",
        data: "https://scraper2.onlineradiobox.com/ru.zaycevpop",
        img: zaycev
      }
    ]);

    let hls;
    let controller;
    let fetched = false;

    const fetcData = async date => {
      controller = new AbortController();
      fetch(`${listRadio.value[0].data}?l=${date}`, {
        signal: controller.signal
      })
        .then(res => {
          fetched = true;
          return res.json();
        })
        .then(json => {
          radioInfo.data = json;
          json.updated && fetcData(json.updated);
        })
        .catch(() => {
          fetched = false;
        });
    };

    const radioData = async () => {
      if (fetched) {
        try {
          controller.abort();
          /* eslint-disable */
        } catch {}
        /* eslint-enable */
      }
      fetcData(0);

      radioInfo.img = listRadio.value[0].img;
      radioInfo.name = listRadio.value[0].name;
      if (listRadio.value[0].play.substr(-4) === "m3u8" && Hls.isSupported()) {
        hls = new Hls();
        hls.loadSource(listRadio.value[0].play);
        hls.attachMedia(player.value);
      } else if (player.value.canPlayType("application/vnd.apple.mpegurl")) {
        player.value.src = listRadio.value[0].play;
      } else {
        player.value.src = listRadio.value[0].play;
      }
    };

    const handleChangeRadio = async (dir = 1) => {
      try {
        hls.destroy();
        /* eslint-disable */
      } catch {}
      /* eslint-enable */
      if (dir == 1) {
        listRadio.value = moveArrayItemToNewIndex(
          listRadio.value,
          listRadio.value.length - 1,
          0
        );
      } else {
        listRadio.value = moveArrayItemToNewIndex(
          listRadio.value,
          0,
          listRadio.value.length - 1
        );
      }
      await radioData();
      player.value.play();
      checkPlayer();
    };

    onMounted(() => {
      volumeChange();
      radioData();
      checkPlayer();
    });
    watch(rangeValue, () => {
      volumeChange();
    });

    return {
      toggleStatus,
      player,
      isPlaying,
      rangeValue,
      volumeIcon,
      volumeNo,
      listRadio,
      radioInfo,
      handleChangeRadio
    };
  }
};
</script>

<style lang="scss" scoped>
img {
  height: 100%;
  width: 100%;
  object-fit: fill;
}
.mobile-plyer {
  display: none;
}
.wrappper-player {
  padding: 0 0.5rem;

  border-radius: 10px 10px 0px 0px;
  width: 100%;
  height: 87px;
  display: grid;
  grid-template-columns: 2.3fr 1.3fr 1fr;
  place-content: center;
  color: #fff;
}
.bg-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.255);
  backdrop-filter: blur(10px);
  z-index: -1;
}
.top-player {
  clip-path: url("#player-btn");
}
.mainBar-player {
  top: 2px;
  clip-path: url("#round-player-btn");
}
.mainBar-control {
  width: 100%;
  margin-right: 10px;
}

.bar-control {
  width: 76%;
  margin-right: 10px;
}
.control {
  display: flex;
  // font-size: 1.5rem;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  .play {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    // width: 110px;
    // height: 110px;
    margin: 0 2.9rem;
    .fa-play {
      transform: translateX(3px);
    }
  }
}
.dinamic {
  background: transparent;
  // font-size: 1.5rem;
  height: auto;
  color: #fff;
}
.voulme {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 80%;
  .slide-voulme {
    display: flex;
    justify-content: center;
    align-items: center;
    input[type="range"],
    input[type="range"]::-webkit-slider-runnable-track,
    input[type="range"]::-webkit-slider-thumb {
      -webkit-appearance: none;
    }
    .slide {
      width: 100%;
      height: 5px;
      // background: #d3d3d4;
      outline: none;
      border-radius: 4px;
    }
    .slide::-webkit-slider-thumb {
      -webkit-appearance: none; /* Override default look */
      appearance: none;
      width: 14px;
      height: 14px;
      background: #fff;
      border-radius: 50%;
      cursor: pointer; /* Cursor on hover */
    }

    input[type="range"]::-moz-range-thumb {
      width: 14px;
      height: 14px;
      background: #fff;
      border-radius: 50%;
      cursor: pointer; /* Cursor on hover */
      border: none;
    }
  }
}
.prev,
.next,
.play {
  cursor: pointer;
  background: transparent;
  color: inherit;
}
.radio-descr {
  height: 100%;
  width: 110%;
  position: relative;
  top: 0;
  left: -10px;
  .main-img {
    transform: translateY(-10%);
  }
  .bar-img {
    height: 50%;
    transform: translateY(28%);
  }
  .img {
    height: 80px;
    bottom: 0;
  }
  .title {
    --snup: 1;
    position: absolute;
    right: 100%;
    width: 309%;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 21px;
    color: #ffffff;
  }
  .main-title {
    top: -24px;
  }
  .bar-title {
    bottom: -5px;
  }
}
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1.5) {
  .player {
    top: 72vh !important;
  }
}
@media screen and (max-width: 992px) {
  .wrappper-player {
    display: none;
  }
  .mobile-plyer {
    display: flex;
    height: 60px;
    align-items: center;
  }
  .mobile-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;

    background: rgba(255, 255, 255, 0.4);
    backdrop-filter: blur(10px);
    z-index: -1;
    clip-path: url("#player-bg-mobile");
  }
  .control-mobile {
    flex: 0 0 50%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    font-size: 3rem;
    .play {
      width: 95px;
      text-align: center;
      .fa-play {
        transform: translateX(5px);
      }
      .fa-pause {
        transform: translateX(-1px);
      }
    }
    .next {
      margin-right: 0rem;
    }
    .prev {
      margin-right: 0rem;
    }
  }
  .info-mobile {
    flex: 0 0 50%;
    width: 100%;
    font-size: 18px;
    line-height: 21px;
    .radio-name {
      text-align: center;
    }
    .radio-music {
      text-align: center;
    }
  }
}
@media screen and (max-width: 600px) {
  .mobile-plyer {
    overflow: hidden;
  }
  .player {
    width: 375px;
    top: 8%;
  }
  .mobile-bg {
    left: -10%;
    width: 120%;
  }
  .control-mobile {
    .play {
      .fa-play {
        transform: translateX(2px);
      }
      .fa-pause {
        transform: translateX(-3px);
      }
    }
  }
}
</style>
